<template>
  <div class="order__food__wrapper">
    <div
      class="last__orders__wrapper"
      v-if="last_orders.length > 0 && order_food.length === 0"
    >
      <h3>Последние заказы</h3>
      <div class="last__orders__items">
        <div
          class="last__order__item"
          v-for="(item, index) in last_orders"
          :key="index"
          @click="func_show_order(item)"
        >
          <div class="date">
            {{ new Date(item.dateOrder).toLocaleDateString() }}
          </div>
          <div class="school">{{ item.school }}</div>
          <div class="class">{{ item.class }}</div>
          <div class="count">Кол-во учащихся: {{ item.count_reb || 0 }}</div>
        </div>
      </div>
    </div>
    <h3>Заказать питание</h3>
    <form @submit.prevent="func_get_data" v-if="order_food.length === 0">
      <div
        class="form__group"
        v-if="USER_STATE && Number(USER_STATE.type) === 5 && false"
      >
        <label>Логин учителя</label>
        <input type="text" v-model="login_teacher" />
      </div>
      <div class="form__group">
        <label>Школа</label>
        <v-select
          label="school"
          :options="school_list"
          v-model="school_value"
          @option:selecting="func_get_class_list"
        />
      </div>
      <div class="form__group">
        <label>Класс</label>
        <v-select
          label="class"
          :options="class_list"
          v-model="class_value"
          @option:selecting="order_food = []"
        />
      </div>
      <div class="form__group">
        <label>Дата</label>
        <input type="date" required v-model="date" />
      </div>
      <button class="send">Заказать питание</button>
    </form>
    <OrderFoodTable
      v-if="order_food.length > 0"
      :order-food="order_food"
      :new-order="new_order"
      :date="date"
      :school-value="school_value"
      :class-value="class_value"
      :selo="selo"
      :dostup="dostup"
      :select-all="selectAllState"
      :check-pp="func_check_pp"
      :check-gpd="func_check_gpd"
      :check-gpd-p="func_check_gpdP"
      :check-gpd-p-d="func_check_gpdPD"
      :check-lg="func_check_lg"
      :get-color="func_get_color"
      :get-summ="func_get_summ"
      @select-all="func_select_all"
      @update-bp-food="func_update_bp_food"
      @update-lg-food="func_update_lg_food"
      @clear="func_clear_order"
      @refresh="func_refresh_student"
      @save="func_save_order"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import orderFoodSelectAll from '@/mixins/orderFoodSelectAll';
import OrderFoodTable from '@/components/Functions/OrderFoodTable.vue';
import {
  refreshStudents,
  getClosedSchool,
  getLastOrders,
  getSchoolListOrder,
  getClassListOrder,
  getSeloSchool,
  getOrderFood,
  saveOrderFood,
} from '@/api/endpoints';
import { parseBoolRows } from '@/utils/flags';
import { balanceColor } from '@/utils/balance';
import { sumItems } from '@/utils/sum';
import {
  countDayDate,
  isDostup,
  checkPp,
  checkGpd,
  checkGpdP,
  checkGpdPD,
  checkLg,
  updateLgFood,
  updateBpFood,
} from '@/utils/orderFood';

const FLAG_FIELDS = [
  'bp',
  'bpO',
  'bpP',
  'pp',
  'ppO',
  'ppP',
  'lgZ1',
  'lgO1',
  'lgP1',
  'lgZ',
  'lgO',
  'gpd',
  'gpdP',
  'gpdPD',
];
const SUMM_KEYS = {
  1: 'bp',
  2: 'bpO',
  3: 'pp',
  4: 'ppO',
  5: 'ppP',
  6: 'lgZ1',
  7: 'lgO1',
  8: 'lgP1',
  9: 'lgZ',
  10: 'lgO',
  11: 'gpd',
  12: 'gpdP',
  13: 'gpdPD',
  14: 'bpP',
};

export default {
  components: {
    OrderFoodTable,
  },
  mixins: [orderFoodSelectAll],
  data() {
    return {
      school_list: [],
      class_list: [],
      school_value: null,
      class_value: null,
      date: '',
      login_teacher: '',
      order_food: [],
      progress: true,
      new_order: true,
      time: '',
      dostup: false,
      send: false,
      last_orders: [],
      selo: false,
      selected: {
        bp: false,
        bpO: false,
        bpP: false,
        pp: false,
        ppO: false,
        ppP: false,
        lgZ1: false,
        lgO1: false,
        lgZ: false,
        lgO: false,
        gpd: false,
        gpdP: false,
        gpdPD: false,
      },
    };
  },
  methods: {
    func_refresh_student() {
      if (confirm('Вы действительно хотите обновить список учеников?')) {
        refreshStudents({
          school_id: this.school_value.school_id,
          class_id: this.class_value.class_id,
          date: this.date,
        }).then(() => {
          this.func_get_data();
        });
      }
    },
    func_check_pp(b, item) {
      return checkPp(b, item, this.dostup);
    },
    func_check_gpd(b, item) {
      return checkGpd(b, item, this.dostup);
    },
    func_check_gpdP(b, item) {
      return checkGpdP(b, item, this.dostup);
    },
    func_check_gpdPD(b, item) {
      return checkGpdPD(b, item, this.dostup);
    },
    func_check_lg(b, item, summ) {
      return checkLg(b, item, summ, this.dostup);
    },
    func_show_order(row) {
      this.school_value = {
        school_id: row.school_id,
        school: row.school,
      };
      this.class_value = {
        class: row.class,
        class_id: row.class_id,
      };
      this.date = row.dateOrder;

      getClosedSchool(row.school_id).then(result => {
          if (!result) {
            this.func_get_data();
          } else {
            this.$notify({
              group: 'foo',
              title: 'Ошибка',
              text: 'Выбранной школе запрещено делать заказ',
              type: 'error',
            });
          }
        });
    },
    func_get_last_orders() {
      getLastOrders().then(result => {
        if (!result) return;
        this.last_orders = result;
      });
    },
    func_update_lg_food(row, column) {
      updateLgFood(row, column);
    },
    func_update_bp_food(row, column) {
      updateBpFood(row, column, this.selo);
    },
    func_close_order() {
      this.order_food = [];
      this.selected = {
        bp: false,
        bpO: false,
        bpP: false,
        pp: false,
        ppO: false,
        ppP: false,
        lgZ1: false,
        lgO1: false,
        lgP1: false,
        lg_zav: false,
        lg_ob: false,
      };
    },
    func_clear_order() {
      this.selected = {
        bp: false,
        bpO: false,
        bpP: false,
        pp: false,
        ppO: false,
        ppP: false,
        lgZ1: false,
        lgO1: false,
        lgP1: false,
        lg_zav: false,
        lg_ob: false,
      };
      this.order_food.forEach(function (item) {
        item.bp = false;
        item.bpO = false;
        item.bpP = false;
        item.pp = false;
        item.ppO = false;
        item.ppP = false;
        item.lgZ1 = false;
        item.lgO1 = false;
        item.lgP1 = false;
        item.lgZ = false;
        item.lgO = false;
        item.gpd = false;
        item.gpdP = false;
        item.gpdPD = false;
      });
    },
    func_save_order() {
      if (this.send) return;
      if (this.order_food.length === 0) {
        window.soundClick();
        this.$notify({
          group: 'foo',
          title: 'Ошибка',
          text: 'Нет данных',
          type: 'error',
        });
        return;
      }
      if (!this.dostup) {
        window.soundClick();
        this.$notify({
          group: 'foo',
          title: 'Ошибка',
          text: 'Нет доступа',
          type: 'error',
        });
        return;
      }
      this.send = true;
      saveOrderFood({
        data: JSON.stringify(this.order_food),
        new_order: this.new_order,
        date: this.date,
        login_teacher: this.login_teacher,
        school_id: this.school_value.school_id,
        class_id: this.class_value.class_id,
      }).then(res => {
          window.soundClick();
          this.$notify({
            group: 'foo',
            title: 'Информация',
            text: 'Выполнено успешно',
            type: 'info',
          });
          this.func_close_order();
          this.send = false;

          if (res) this.last_orders.unshift(res);
        });
    },
    func_get_school_list() {
      getSchoolListOrder().then(result => {
        if (!result) return;
        this.school_list = result;
      });
    },
    func_get_class_list(item) {
      if (!item.school_id) return;
      getClosedSchool(item.school_id).then(result => {
        if (!result) {
          this.school_value = item;
          getClassListOrder(this.school_value.school_id).then(result => {
            if (!result) return;
            this.class_list = result;
          });
        } else {
          this.class_list = [];
          this.$notify({
            group: 'foo',
            title: 'Ошибка',
            text: 'Выбранной школе запрещено делать заказ',
            type: 'error',
          });
        }
      });
    },
    func_get_selo_school() {
      getSeloSchool(this.school_value.school_id).then(result => {
        if (!result) return;
        this.selo = result.selo;
      });
    },
    func_get_data() {
      if (this.school_value && this.class_value && this.date) {
        this.func_get_selo_school();
        const countDay = Math.ceil(
          (new Date(this.date) - new Date()) / (60 * 60 * 24 * 1000),
        );
        if (countDay > 17) {
          this.$notify({
            group: 'foo',
            title: 'Ошибка',
            text: 'Дата заказа не может быть больше текущей чем на 17 дней',
            type: 'error',
          });
          return;
        }
        getOrderFood({
          school_id: this.school_value.school_id,
          class_id: this.class_value.class_id,
          date: this.date,
        }).then(result => {
            if (!result) return;
            parseBoolRows(result.data, FLAG_FIELDS);
            this.order_food = result.data;
            this.new_order = result.new;
            this.time = result.time;
            this.func_dostup();
          });
      } else {
        window.soundClick();
        this.$notify({
          group: 'foo',
          title: 'Ошибка',
          text: 'Заполните поля',
          type: 'error',
        });
      }
    },
    func_get_color(obj) {
      if (!obj) return;
      return balanceColor(obj.balance);
    },
    func_dostup() {
      this.dostup = isDostup(this.time, this.date, new Date());
    },

    func_get_count_day_date(start, end) {
      return countDayDate(start, end);
    },
    func_get_summ(num) {
      return sumItems(this.order_food, num, SUMM_KEYS);
    },
    func_select_all(name, value) {
      this[name] = value;
    },
  },
  mounted() {
    this.func_get_school_list();
    this.func_get_last_orders();
  },
  computed: {
    ...mapGetters(['USER_STATE']),
    selectAllState() {
      return {
        select_all_bp: this.select_all_bp,
        select_all_bpO: this.select_all_bpO,
        select_all_bpP: this.select_all_bpP,
        select_all_pp: this.select_all_pp,
        select_all_ppO: this.select_all_ppO,
        select_all_ppP: this.select_all_ppP,
        select_all_lgZ1_food: this.select_all_lgZ1_food,
        select_all_lgO1_food: this.select_all_lgO1_food,
        select_all_lgP1_food: this.select_all_lgP1_food,
        select_all_lg_zav: this.select_all_lg_zav,
        select_all_lg_ob: this.select_all_lg_ob,
        select_all_lg_gpd: this.select_all_lg_gpd,
        select_all_lg_gpdP: this.select_all_lg_gpdP,
        select_all_lg_gpdPD: this.select_all_lg_gpdPD,
      };
    },
  },
};
</script>

<style>
.btn__refresh_student {
  margin-bottom: 20px;
  background: #f9d45c;
  color: #fff;
  text-decoration: none;
  text-align: center;
  padding: 10px 15px;
  cursor: pointer;
  border: 0;
  border-radius: 5px;
  transition: 0.5s;
  display: block;
}
</style>
